import { SELECT_INGREDIENT_IN_GROCERY_LIST } from "./actionTypes";

export default (selectObject) => ({
  type: SELECT_INGREDIENT_IN_GROCERY_LIST,
  payload: {
    selectObject,
  }
});